import { EnvVarManager } from '@/env/envVarManager';

export const isDevelopment = EnvVarManager.getEnvVar('NEXT_PUBLIC_APP_ENV') === 'development';
